import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatDate = (date: string): string => format(new Date(date), 'dd.MM.yy', { locale: ru });
